<template>
  <div id="warp" class="wide">
    <div id="action">
      <div>
        <p>{{ $t('enter.code.from.sms') }}</p>
      </div>

      <div>
        <form ref="submitFrame" method="GET" target="securePayment" :action="data.action">
          <input v-if="data.md" type="hidden" name="MD" :value="data.md" />
          <input v-if="data.paReq" type="hidden" name="PaReq" :value="data.paReq" />
          <input v-if="data.termUrl" type="hidden" name="TermUrl" :value="data.termUrl" />
          <input v-if="data.creq" type="hidden" name="creq" :value="data.creq" />
        </form>

        <iframe
          id="capusta-3ds-frame"
          ref="frameSecure"
          name="securePayment"
          @load="iframeUpdate"
        ></iframe>

        <div class="spinner"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => new Object(),
    },
  },
  mounted() {
    if (!Object.keys(this.data).length) { return this.$router.go(-1); }
    this.$refs.submitFrame.submit();
  },
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    iframeUpdate() {
      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
iframe
  width: 100%
  border: none
  height: 80vh

.spinner
  border: 8px solid rgba(245, 255, 250, 0.1)
  border-left-color: #7bb86c
  height: 60px
  width: 60px
  border-radius: 50%
  animation: spin 1s linear infinite
  position: absolute
  left: 0
  right: 0
  top: 40%
  margin: 0 auto
  z-index: -1

@keyframes spin
  to
    transform: rotate(360deg)
</style>
